import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { getDocument } from "@faire/web--source/common/globals/getDocument";
import { useFloating, size, hide, useInteractions, useDismiss, offset, autoUpdate, flip } from "@floating-ui/react";
import * as React from "react";
var ABOVE_MODAL_Z_INDEX = 1050;
var DEFAULT_Z_INDEX = 5;
var PopoverContext = /*#__PURE__*/ React.createContext(undefined);
export var usePopoverContext = function() {
    var context = React.useContext(PopoverContext);
    if (!context) {
        throw new Error("usePopoverContext must be used within a PopoverProvider");
    }
    return context;
};
export var PopoverProvider = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    var open = props.open, anchorRef = props.anchorRef, _props_placement = props.placement, placement = _props_placement === void 0 ? "bottom-start" : _props_placement, zIndex = props.zIndex, isModal = props.isModal, mainAxisOffset = props.mainAxisOffset, crossAxisOffset = props.crossAxisOffset, width = props.width, height = props.height, disableFlip = props.disableFlip, onClickOutside = props.onClickOutside;
    var bodyRef = React.useRef(null);
    React.useEffect(function() {
        var _getDocument;
        var _getDocument_body;
        bodyRef.current = (_getDocument_body = (_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.body) !== null && _getDocument_body !== void 0 ? _getDocument_body : null;
    }, []);
    var enableFlip = !disableFlip && !!height; // Flip requires height to work
    var popoverZIndex = zIndex !== null && zIndex !== void 0 ? zIndex : isModal ? ABOVE_MODAL_Z_INDEX : DEFAULT_Z_INDEX;
    var floatingData = useFloating(_object_spread_props(_object_spread({}, anchorRef ? {
        elements: {
            reference: anchorRef
        }
    } : {}), {
        placement: placement,
        middleware: [
            size({
                apply: function(param) {
                    var rects = param.rects, elements = param.elements;
                    elements.floating.style.width = width ? "".concat(width, "px") : "".concat(rects.reference.width, "px");
                    if (height) {
                        elements.floating.style.height = "".concat(height, "px");
                    }
                }
            })
        ].concat(_to_consumable_array(enableFlip ? [
            flip({
                fallbackStrategy: "initialPlacement"
            })
        ] : []), [
            offset({
                mainAxis: mainAxisOffset !== null && mainAxisOffset !== void 0 ? mainAxisOffset : 0,
                crossAxis: crossAxisOffset !== null && crossAxisOffset !== void 0 ? crossAxisOffset : 0
            }),
            hide({
                strategy: "escaped"
            }),
            hide({
                strategy: "referenceHidden"
            })
        ]),
        open: open,
        onOpenChange: onClickOutside,
        whileElementsMounted: autoUpdate
    }));
    var floatingInteractions = useInteractions([
        useDismiss(floatingData.context)
    ]);
    return /*#__PURE__*/ _jsx(PopoverContext.Provider, {
        value: _object_spread_props(_object_spread({}, props), {
            floatingData: floatingData,
            floatingInteractions: floatingInteractions,
            bodyRef: bodyRef,
            popoverZIndex: popoverZIndex
        }),
        children: children
    });
};
